import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import {
  TextField,
  Button,
  CircularProgress,
  Typography,
  Paper,
  Grid,
  Box,
} from "@mui/material";

const MiComponente = () => {
  const { idNuevo } = useParams();
  const { idAntiguo } = useParams();
  const navigate = useNavigate();
  const [jsonData, setJsonData] = useState([]);
  const [formData, setFormData] = useState(null);
  const [mensaje, setMensaje] = useState("Cargando datos...");
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        const response = await axios.get(
          `https://portaltransaccionalback.azurewebsites.net/api/GetFormularios/${idNuevo}`
        );
        setJsonData(response.data);
        setMensaje("Datos cargados correctamente ✅");

        if (response.data.length > 0) {
          const item = response.data[0];
          setFormData({
            descripcion: item.a.descripcion || "",
            titulo: item.a.titulo || "",
            estado: item.a.estado?.toString() || "",
            publicacion: item.a.publicacion || "",
            lineaServicio: item.a.lineaServicio || "",
            canal: item.a.canal || "",
            tipo: item.s.tipo || "",
            nombre: item.s.nombre || "",
            nuevaOpcion: item.s.nuevaOpcion || "",
            opciones: item.opciones ? item.opciones.map((op) => op.opcion) : [],
          });
        }
      } catch (error) {
        console.error("Error al obtener datos:", error);
        setMensaje("Error al obtener datos ❌");
      }
    };

    obtenerDatos();
  }, [idNuevo]);

  const clonarDatos = async () => {
    setCargando(true);
    try {
      const responseS = await axios.post(
        "https://portaltransaccionalback.azurewebsites.net/api/CreaPregunta",
        {
          tipo: formData.tipo,
          nombre: formData.nombre,
          nuevaOpcion: formData.nuevaOpcion,
          idFormPrincipal: idAntiguo,
        }
      );

      const desplegableId = responseS.data;

      const opcionesPromises = formData.opciones.map((opcion) =>
        axios.post(
          "https://portaltransaccionalback.azurewebsites.net/api/CreaOpcion",
          {
            desplegableId,
            opcion,
          }
        )
      );

      await Promise.all(opcionesPromises);

      setMensaje("Datos clonados correctamente ✅");

      Swal.fire({
        icon: "success",
        title: "¡Clonado con éxito!",
        text: "El formulario ha sido clonado correctamente.",
        confirmButtonText: "Aceptar",
      }).then(() => {
        navigate("/Principales");
      });
    } catch (error) {
      console.error("Error al clonar datos:", error);
      setMensaje("El formulario no cuneta con Campos Variables ❌");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema al clonar los datos.",
      });
    }
    setCargando(false);
  };

  const confirmarClonacion = () => {
    Swal.fire({
      title: "¿Confirmar clonación?",
      text: "¿Estás seguro de que deseas clonar este formulario?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, clonar",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        clonarDatos();
      }
    });
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
      <Paper sx={{ p: 4, width: "100%", maxWidth: 600 }} elevation={3}>
        <Typography variant="h5" gutterBottom>
          Clonar Formulario
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          {mensaje}
        </Typography>

        {formData ? (
          <form onSubmit={(e) => e.preventDefault()}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Tipo"
                  name="tipo"
                  disabled
                  variant="outlined"
                  value={formData.tipo}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Nombre"
                  name="nombre"
                  disabled
                  variant="outlined"
                  value={formData.nombre}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6">Opciones</Typography>
              </Grid>

              {formData.opciones.map((opcion, index) => (
                <Grid item xs={12} key={index}>
                  <TextField
                    fullWidth
                    label={`Opción ${index + 1}`}
                    variant="outlined"
                    value={opcion}
                    disabled
                  />
                </Grid>
              ))}

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={confirmarClonacion}
                  disabled={cargando}
                >
                  {cargando ? <CircularProgress size={24} /> : "Clonar"}
                </Button>
              </Grid>
            </Grid>
          </form>
        ) : (
          <Typography variant="body1" align="center">
            Cargando formulario...
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default MiComponente;
